import { DefaultZIndexes } from 'recharts';

// Recharts 3 paints axes above reference lines by default, masking targets at plot edges.
// Its scatter layer sits above axes and below labels and the note overlay.
export const REFERENCE_LINE_Z_INDEX = DefaultZIndexes.scatter;
// Data lines follow reference lines in JSX, so the same layer keeps readings on top.
export const DATA_LINE_Z_INDEX = REFERENCE_LINE_Z_INDEX;
// Recharts 3 can reorder same-layer lines; the authored trend follows pressure.
export const TREND_LINE_Z_INDEX = DefaultZIndexes.activeBar;
